<dialog
  class="modal"
  #dialog
  (close)="dialogCloseHandler()"
  *ngxPermissionsExcept="guest">
  <div class="modal-box max-w-[480px]">
    <form #form="ngForm" (ngSubmit)="submitHandler(form)">
      <label class="form-control w-full">
        <div class="label">
          <span class="label-text">Khu vực giới thiệu</span>
        </div>
        <select
          class="select select-bordered select-sm"
          name="leadRegion"
          #leadRegion="ngModel"
          [ngModel]="''"
          required>
          @for (item of regions; track $index) {
            <option [value]="item">{{ item }}</option>
          }
        </select>
        @if ((leadRegion.touched || leadRegion.dirty) && leadRegion.errors) {
          <div class="text-error">
            @if (leadRegion.errors['required']) {
              Khu vực giới thiệu không được để trống
            }
          </div>
        }
      </label>
      <label class="form-control w-full">
        <div class="label">
          <span class="label-text">Tỉnh giới thiệu</span>
        </div>
        <select
          class="select select-bordered select-sm"
          name="leadProvince"
          #leadProvince="ngModel"
          [ngModel]="''"
          required>
          @for (item of provinces; track $index) {
            <option [value]="item">{{ item }}</option>
          }
        </select>
        @if (
          (leadProvince.touched || leadProvince.dirty) && leadProvince.errors
        ) {
          <div class="text-error">
            @if (leadProvince.errors['required']) {
              Tỉnh giới thiệu không được để trống
            }
          </div>
        }
      </label>
      <label class="form-control w-full">
        <div class="label">
          <span class="label-text">Khu vực phát triển</span>
        </div>
        <select
          class="select select-bordered select-sm"
          name="selfRegion"
          #selfRegion="ngModel"
          [ngModel]="''"
          required>
          @for (item of regions; track $index) {
            <option [value]="item">{{ item }}</option>
          }
        </select>
        @if ((selfRegion.touched || selfRegion.dirty) && selfRegion.errors) {
          <div class="text-error">
            @if (selfRegion.errors['required']) {
              Khu vực phát triển không được để trống
            }
          </div>
        }
      </label>
      <label class="form-control w-full">
        <div class="label">
          <span class="label-text">Tỉnh phát triển</span>
        </div>
        <select
          class="select select-bordered select-sm"
          name="selfProvince"
          #selfProvince="ngModel"
          [ngModel]="''"
          required>
          @for (item of provinces; track $index) {
            <option [value]="item">{{ item }}</option>
          }
        </select>
        @if (
          (selfProvince.touched || selfProvince.dirty) && selfProvince.errors
        ) {
          <div class="text-error">
            @if (selfProvince.errors['required']) {
              Tỉnh phát triển không được để trống
            }
          </div>
        }
      </label>
      <div class="flex w-full justify-end p-2">
        <button type="submit" class="btn btn-primary btn-sm">Lưu</button>
      </div>
    </form>
  </div>
  @if (loading()) {
    <div
      class="layout-base absolute left-1/2 top-0 z-40 flex h-[100vh] w-full -translate-x-1/2 items-center justify-center bg-gray-600/30">
      <span class="loading loading-bars loading-lg text-primary"></span>
    </div>
  }
</dialog>

<market-confirm-dialog
  [title]="'Xác nhận'"
  [content]="
    'Bạn có muốn xác nhận thông tin này không?'
  "></market-confirm-dialog>
